module.exports = __webpack_public_path__ + "static/media/vf-button-men-dress-shoes.5ec227b7.svg";